import Vue from "vue";
export var ErrorEventBus = new Vue();
export var SuccessEventBus = new Vue();
export var ClearEventBus = new Vue();